import { useEffect, useState } from 'react'
import { fetchFirmwareVersions, FirmwareVersion } from '../utils/fwService'

export function useFirmwareVersions() {
    const [data, setData] = useState<FirmwareVersion[] | null>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        const ctrl = new AbortController()
        setLoading(true)
        fetchFirmwareVersions(ctrl.signal)
            .then(setData)
            .catch((e: Error) => setError(e instanceof Error ? e.message : String(e)))
            .finally(() => setLoading(false))
        return () => ctrl.abort()
    }, [])

    return { data, loading, error }
}
